import Vue from "vue";
import { mapState } from "vuex";
import VueRouter from "vue-router";
Vue.use(VueRouter);

import Login from "../components/app/auth/Login.vue";

// Master Pasien
import MergePasien from "../components/app/home/master_pasien/MergePasien.vue";
import MergePasienDetails from "../components/app/home/master_pasien/MergePasienDetails.vue";
import NonAktifPasien from "../components/app/home/master_pasien/NonaktifPasien.vue";
import GantiNoRM from "../components/app/home/master_pasien/GantiNoRM.vue";
import ScanBerkasRM from "../components/app/home/master_pasien/ScanBerkasRM.vue";
import ScanBerkasRMDetails from "../components/app/home/master_pasien/ScanBerkasRMDetails.vue";
import UpdatePasien from "../components/app/home/master_pasien/UpdatePasien.vue";
import UpdatePasienDetails from "../components/app/home/master_pasien/UpdatePasienDetails.vue";
import GantiRegistrasi from "../components/app/home/ganti_registrasi_pasien/GantiRegistrasi.vue";

// Retensi dan Pemusnahan
import PasienTidakAktif5Tahun from "../components/app/home/retensi_dan_pemusnahan/PasienTidakAktif5Tahun.vue";
import PasienTidakAktif5TahunDetails from "../components/app/home/retensi_dan_pemusnahan/PasienTidakAktif5TahunDetails.vue";
import DokumenPasien from "../components/app/home/retensi_dan_pemusnahan/DokumenPasien.vue";
import DataMRTidakAktif from "../components/app/home/retensi_dan_pemusnahan/DataMRTidakAktif.vue";
import LaporanRetensiDanPemusnahan from "../components/app/home/retensi_dan_pemusnahan/LaporanRetensiDanPemusnahan.vue";

/* ocha */
import PasienCheckIn from "../components/app/home/PasienCheckIn.vue";
import KonsulAntarPoli from "../components/app/home/KonsulAntarPoli.vue";
import KonsulAntarPoliDetail from "../components/app/home/KonsulAntarPoliDetail.vue";
import PasienRawat from "../components/app/home/PasienRawat.vue";
import PasienRawatDetail from "../components/app/home/PasienRawatDetail.vue";
import SelesaiPelayanan from "../components/app/home/SelesaiPelayanan.vue";
import PasienMeninggal from "../components/app/home/PasienMeninggal.vue";
import PencarianPasien from "../components/app/home/PencarianPasien.vue";

/* Monitoring Pasien */
import FileStatusKeluar from "../components/app/home/monitoring_pasien/FileStatusKeluar.vue";
import FileStatusMasuk from "../components/app/home/monitoring_pasien/FileStatusMasuk.vue";
import FileStatusBelumKembali from "../components/app/home/monitoring_pasien/FileStatusBelumKembali.vue";
import MonitoringFileStatus from "../components/app/home/monitoring_pasien/MonitoringFileStatus.vue";

// Riwayat Pasien
import RiwayatPasien from "../components/app/home/riwayat_pasien/RiwayatPasien.vue";
import RiwayatPasienDetail from "../components/app/home/riwayat_pasien/RiwayatPasienDetail.vue";

// Master ICDX
import masterICDX from "../components/app/home/icdx/ListICDX.vue";
import UpdateICDX from "../components/app/home/icdx/UpdateICDX.vue";
import TambahICDX from "../components/app/home/icdx/TambahICDX.vue";

// Master ICD9
import masterICD9 from "../components/app/home/icd9/ListICD9.vue";
import UpdateICD9 from "../components/app/home/icd9/UpdateICD9.vue";
import TambahICD9 from "../components/app/home/icd9/TambahICD9.vue";

// Pasien ICD
import listPasienICD from "../components/app/home/pasienicd/ListPasienICD.vue";
import UpdateICD from "../components/app/home/pasienicd/UpdateICD.vue";
import UpdateICDRanap from "../components/app/home/pasienicd/UpdateICDRanap.vue";
// import UpdateICDPasien from "../components/app/home/pasienicd/UpdateICDPasien-old.vue/index.js";

import externalRS from "../components/app/home/external/rs/externalRS.vue";
import externalPelayanan from "../components/app/home/external/pelayanan/externalPelayanan.vue";
import externalTempatTidur from "../components/app/home/external/pelayanan/externalTempatTidur.vue";
import externalKetenagaan from "../components/app/home/external/pelayanan/externalKetenagaan.vue";
import externalRanap from "../components/app/home/external/pelayanan/externalRanap.vue";
import externalGigiMulut from "../components/app/home/external/pelayanan/externalGigiMulut.vue";
import externalPengunjung from "../components/app/home/external/pelayanan/externalPengunjung.vue";
import externalKunjunganRajal from "../components/app/home/external/pelayanan/externalKunjunganRajal.vue";
import externalPenyakitRanap from "../components/app/home/external/pelayanan/externalPenyakitRanap.vue";
import externalPenyakitRajal from "../components/app/home/external/pelayanan/externalPenyakitRajal.vue";
import ProfilRumahSakit from "../components/app/rlexternal/identitas-rumah-sakit/ProfilRumahSakit.vue";
import KetersediaanPelayanan from "../components/app/rlexternal/identitas-rumah-sakit/KetersediaanPelayanan.vue";
import KetersediaanTempatTidur from "../components/app/rlexternal/identitas-rumah-sakit/KetersediaanTempatTidur.vue";
import IndikatorPelayanan from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/IndikatorPelayanan.vue";
import KegiatanPelayananRanap from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanPelayananRanap.vue";
import KegiatanRawatDarurat from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanRawatDarurat.vue";
import RekapitulasiPengunjung from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/RekapitulasiPengunjung.vue";
import RekapitulasiKunjungan from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/RekapitulasiKunjungan.vue";
import KegiatanPelayananKebidanan from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanPelayananKebidanan.vue";
import KegiatanPelayananNeonatal from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanPelayananNeonatal.vue";
import KegiatanLaboratorium from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanLaboratorium.vue";
import KegiatanRadiologi from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanRadiologi.vue";
import KegiatanPelayananRujukan from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanPelayananRujukan.vue";
import KegiatanPelayananGigi from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanPelayananGigi.vue";
import KegiatanPelayananPembedahan from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanPelayananPembedahan.vue";
import KegiatanRehabilitasiMedik from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanRehabilitasiMedik.vue";
import KegiatanPelayananKhusus from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanPelayananKhusus.vue";
import KegiatanPelayananJiwa from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanPelayananJiwa.vue";
import KegiatanPelayananKB from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanPelayananKB.vue";
import KegiatanPelayananFarmasi from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanPelayananFarmasi.vue";
import KegiatanPelayananFarmasiResep from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/KegiatanPelayananFarmasiResep.vue";
import RekapitulasiCaraBayar from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/RekapitulasiCaraBayar.vue";
import BesarPenyakitRanap from "../components/app/rlexternal/mordibilitas-ranap/BesarPenyakitRanap.vue";
import BesarKematianRanap from "../components/app/rlexternal/mordibilitas-ranap/BesarKematianRanap.vue";
import MordibilitasRanap from "../components/app/rlexternal/mordibilitas-ranap/MordibilitasRanap.vue";
import MordibilitasRajal from "../components/app/rlexternal/morbiditas-rajal/MordibilitasRajal.vue";
import BesarPenyakitRajal from "../components/app/rlexternal/morbiditas-rajal/BesarPenyakitRajal.vue";
import BesarPenyakitKunjunganRajal from "../components/app/rlexternal/morbiditas-rajal/BesarPenyakitKunjunganRajal.vue";
import DaftarRujukan from "../components/app/rlexternal/rekapitulasi-kegiatan-pelayanan/DaftarRujukan.vue";
import UpdateKategoriCaraBayar from "../components/app/home/update_kategori_carabayar/UpdateKategoriCaraBayar.vue";
const routes = [
    {
        name: "login",
        path: "/login",
        component: Login,
    },
    // Master Pasien
    {
        name: "merge_pasien",
        path: "/merge-data-pasien",
        component: MergePasien,
    },
    {
        name: "merge_pasien_details",
        path: "/merge-data-pasien/:Medrec",
        component: MergePasienDetails,
    },
    {
        name: "nonaktif_pasien",
        path: "/nonaktif-data-pasien",
        component: NonAktifPasien,
    },
    {
        name: "ganti_nomor_rm",
        path: "/ganti-nomor-rm",
        component: GantiNoRM,
    },
    {
        name: "scan_berkas_rm",
        path: "/scan-berkas-rm",
        component: ScanBerkasRM,
    },
    {
        name: "scan_berkas_rm_details",
        path: "/scan-berkas-rm/:Medrec",
        component: ScanBerkasRMDetails,
    },
    {
        name: "ganti-registrasi",
        path: "/ganti-registrasi",
        component: GantiRegistrasi,
    },
    {
        name: "update-kategori-cara-bayar",
        path: "/update-kategori-cara-bayar",
        component: UpdateKategoriCaraBayar,
    },
    {
        name: "update_pasien",
        path: "/update-pasien",
        component: UpdatePasien,
    },
    {
        name: "update_pasien_details",
        path: "/update-pasien/:Medrec",
        component: UpdatePasienDetails,
    },

    // Retensi dan Pemusnahan
    {
        name: "pasien_tidak_aktif_5_tahun",
        path: "/pasien-tidak-aktif-5-tahun",
        component: PasienTidakAktif5Tahun,
    },
    {
        name: "pasien_tidak_aktif_5_tahun_details",
        path: "/pasien-tidak-aktif-5-tahun/:Medrec",
        component: PasienTidakAktif5TahunDetails,
    },
    {
        name: "dokumen_pasien",
        path: "/daftar-dokumen-pasien/:Medrec",
        component: DokumenPasien,
    },
    {
        name: "data_mr_tidak_aktif",
        path: "/data-mr-tidak-aktif",
        component: DataMRTidakAktif,
    },
    {
        name: "laporan_retensi_dan_pemusnahan",
        path: "/laporan-retensi-dan-pemusnahan",
        component: LaporanRetensiDanPemusnahan,
    },

    /* ocha */
    {
        name: "pasien_check_in",
        path: "/pasien-check-in",
        component: PasienCheckIn,
    },
    {
        name: "konsul_antar_poli",
        path: "/konsul-antar-poli",
        component: KonsulAntarPoli,
    },
    {
        name: "konsul_antar_poli_detail",
        path: "/konsul-antar-poli/:Regno",
        component: KonsulAntarPoliDetail,
    },
    {
        name: "sensus_harian_pasien",
        path: "/sensus-harian-pasien",
        component: PasienRawat,
    },
    {
        name: "sensus_harian_pasien_detail",
        path: "/sensus-harian-pasien/:Regno",
        component: PasienRawatDetail,
    },
    {
        name: "selesai_pelayanan",
        path: "/selesai-pelayanan",
        component: SelesaiPelayanan,
    },
    {
        name: "pasien_meninggal",
        path: "/pasien-meninggal",
        component: PasienMeninggal,
    },
    {
        name: "pencarian_pasien",
        path: "/pencarian-pasien",
        component: PencarianPasien,
    },
    {
        name: "riwayat_pasien",
        path: "/riwayat-pasien",
        component: RiwayatPasien,
    },
    {
        name: "riwayat_pasien_detail",
        path: "/riwayat-pasien/:medrec",
        component: RiwayatPasienDetail,
    },
    {
        name: "file-status-keluar",
        path: "/file_status_keluar",
        component: FileStatusKeluar,
    },
    {
        name: "file-status-masuk",
        path: "/file_status_masuk",
        component: FileStatusMasuk,
    },
    {
        name: "file-status-belum-kembali",
        path: "/file_status_belum_kembali",
        component: FileStatusBelumKembali,
    },
    {
        name: "monitoring-file-status",
        path: "/monitoring_file_status",
        component: MonitoringFileStatus,
    },
    {
        name: "master_icdx",
        path: "/master-icdx",
        component: masterICDX,
    },
    {
        name: "updateICDX",
        path: "/update-icdx/:KDICD",
        component: UpdateICDX,
    },
    {
        name: "tambahICDX",
        path: "/tambah-icdx",
        component: TambahICDX,
    },
    {
        name: "master_icd9",
        path: "/master-icd9",
        component: masterICD9,
    },
    {
        name: "updateICD9",
        path: "/update-icd9/:KDICD",
        component: UpdateICD9,
    },
    {
        name: "tambahICD9",
        path: "/tambah-icd9",
        component: TambahICD9,
    },
    {
        name: "listPasienICD",
        path: "/pasien-icd",
        component: listPasienICD,
    },
    {
        name: "updateICD",
        path: "/update-icd/:Regno",
        component: UpdateICD,
    },
    {
        name: "updateICDRanap",
        path: "/update-icd-ranap/:Regno",
        component: UpdateICDRanap,
    },
    // {
    //     name: "updateICDPasien",
    //     path: "/update-icd-pasien/:Regno/:IdCPPT/:IdMasterForm",
    //     component: UpdateICDPasien,
    // },
    {
        name: "externalRS",
        path: "/external-rs",
        component: externalRS,
    },
    {
        name: "externalPelayanan",
        path: "/external-pelayanan",
        component: externalPelayanan,
    },
    {
        name: "externalTempatTidur",
        path: "/external-tempat-tidur",
        component: externalTempatTidur,
    },
    {
        name: "externalKetenagaan",
        path: "/external-ketenagaan",
        component: externalKetenagaan,
    },
    {
        name: "externalRanap",
        path: "/external-ranap",
        component: externalRanap,
    },
    {
        name: "externalGigiMulut",
        path: "/external-gigi-mulut",
        component: externalGigiMulut,
    },
    {
        name: "externalPengunjung",
        path: "/external-pengunjung",
        component: externalPengunjung,
    },
    {
        name: "externalKunjunganRajal",
        path: "/external-kunjungan-rajal",
        component: externalKunjunganRajal,
    },
    {
        name: "externalPenyakitRanap",
        path: "/external-penyakit-ranap",
        component: externalPenyakitRanap,
    },
    {
        name: "externalPenyakitRajal",
        path: "/external-penyakit-rajal",
        component: externalPenyakitRajal,
    },
    {
        name: "identitas-rumah-sakit-profil-rumah-sakit",
        path: "/identitas-rumah-sakit/profil-rumah-sakit",
        component: ProfilRumahSakit,
    },
    {
        name: "identitas-rumah-sakit-ketersediaan-pelayanan",
        path: "/identitas-rumah-sakit/ketersediaan-pelayanan",
        component: KetersediaanPelayanan,
    },
    {
        name: "identitas-rumah-sakit-ketersediaan-tempat-tidur",
        path: "/identitas-rumah-sakit/ketersediaan-tempat-tidur",
        component: KetersediaanTempatTidur,
    },
    {
        name: "rekapitulasi-pelayanan-indikator-pelayanan",
        path: "/rekapitulasi-pelayanan/indikator-pelayanan",
        component: IndikatorPelayanan,
    },
    {
        name: "rekapitulasi-pelayanan-kegiatan-pelayanan-rawat-inap",
        path: "/rekapitulasi-pelayanan/kegiatan-pelayanan-rawat-inap",
        component: KegiatanPelayananRanap,
    },
    {
        name: "rekapitulasi-pelayanan-kegiatan-pelayanan-rawat-darurat",
        path: "/rekapitulasi-pelayanan/kegiatan-pelayanan-rawat-darurat",
        component: KegiatanRawatDarurat,
    },
    {
        name: "rekapitulasi-pelayanan-rekapitulasi-jumlah-pengunjung",
        path: "/rekapitulasi-pelayanan/rekapitulasi-jumlah-pengunjung",
        component: RekapitulasiPengunjung,
    },
    {
        name: "rekapitulasi-pelayanan-rekapitulasi-jumlah-kunjungan",
        path: "/rekapitulasi-pelayanan/rekapitulasi-jumlah-kunjungan",
        component: RekapitulasiKunjungan,
    },
    {
        name: "rekapitulasi-pelayanan-kegiatan-pelayanan-kebidanan",
        path: "/rekapitulasi-pelayanan/kegiatan-pelayanan-kebidanan",
        component: KegiatanPelayananKebidanan,
    },
    {
        name: "rekapitulasi-pelayanan-kegiatan-pelayanan-neonatal",
        path: "/rekapitulasi-pelayanan/kegiatan-pelayanan-neonatal",
        component: KegiatanPelayananNeonatal,
    },
    {
        name: "rekapitulasi-pelayanan-kegiatan-pelayanan-laboratorium",
        path: "/rekapitulasi-pelayanan/kegiatan-pelayanan-laboratorium",
        component: KegiatanLaboratorium,
    },
    {
        name: "rekapitulasi-pelayanan-kegiatan-pelayanan-radiologi",
        path: "/rekapitulasi-pelayanan/kegiatan-pelayanan-radiologi",
        component: KegiatanRadiologi,
    },
    {
        name: "rekapitulasi-pelayanan-kegiatan-pelayanan-rujukan",
        path: "/rekapitulasi-pelayanan/kegiatan-pelayanan-rujukan",
        component: KegiatanPelayananRujukan,
    },
    {
        name: "rekapitulasi-pelayanan-kegiatan-pelayanan-gigi-dan-mulut",
        path: "/rekapitulasi-pelayanan/kegiatan-pelayanan-gigi-dan-mulut",
        component: KegiatanPelayananGigi,
    },
    {
        name: "rekapitulasi-pelayanan-kegiatan-pelayanan-pembedahan",
        path: "/rekapitulasi-pelayanan/kegiatan-pelayanan-pembedahan",
        component: KegiatanPelayananPembedahan,
    },
    {
        name: "rekapitulasi-pelayanan-kegiatan-pelayanan-rehabilitasi-medik",
        path: "/rekapitulasi-pelayanan/kegiatan-pelayanan-rehabilitasi-medik",
        component: KegiatanRehabilitasiMedik,
    },
    {
        name: "rekapitulasi-pelayanan-kegiatan-pelayanan-khusus",
        path: "/rekapitulasi-pelayanan/kegiatan-pelayanan-khusus",
        component: KegiatanPelayananKhusus,
    },
    {
        name: "rekapitulasi-pelayanan-kegiatan-pelayanan-kesehatan-jiwa",
        path: "/rekapitulasi-pelayanan/kegiatan-pelayanan-kesehatan-jiwa",
        component: KegiatanPelayananJiwa,
    },
    {
        name: "rekapitulasi-pelayanan-kegiatan-pelayanan-keluarga-berencana",
        path: "/rekapitulasi-pelayanan/kegiatan-pelayanan-keluarga-berencana",
        component: KegiatanPelayananKB,
    },
    {
        name: "rekapitulasi-pelayanan-kegiatan-pelayanan-farmasi-rs-pengadaan-obat",
        path: "/rekapitulasi-pelayanan/kegiatan-pelayanan-farmasi-rs-pengadaan-obat",
        component: KegiatanPelayananFarmasi,
    },
    {
        name: "rekapitulasi-pelayanan-kegiatan-pelayanan-armasi-rumah-sakit-resep",
        path: "/rekapitulasi-pelayanan/kegiatan-pelayanan-farmasi-rumah-sakit-resep",
        component: KegiatanPelayananFarmasiResep,
    },
    {
        name: "rekapitulasi-pelayanan-rekapitulasi-cara-bayar",
        path: "/rekapitulasi-pelayanan/rekapitulasi-cara-bayar",
        component: RekapitulasiCaraBayar,
    },
    {
        name: "rekapitulasi-morbiditas-rawat-inap",
        path: "/rekapitulasi-morbiditas/rawat-inap",
        component: MordibilitasRanap,
    },
    {
        name: "rekapitulasi-morbiditas-10-besar-penyakit",
        path: "/rekapitulasi-morbiditas/10-besar-penyakit-rawat-inap",
        component: BesarPenyakitRanap,
    },
    {
        name: "rekapitulasi-morbiditas-10-besar-kematian",
        path: "/rekapitulasi-morbiditas/10-besar-kematian-rawat-inap",
        component: BesarKematianRanap,
    },
    {
        name: "rekapitulasi-morbiditas-rawat-jalan",
        path: "/rekapitulasi-morbiditas/rawat-jalan",
        component: MordibilitasRajal,
    },
    {
        name: "rekapitulasi-morbiditas-10-besar-penyakit-rawat-jalan",
        path: "/rekapitulasi-morbiditas/10-besar-penyakit-rawat-jalan",
        component: BesarPenyakitRajal,
    },
    {
        name: "rekapitulasi-morbiditas-10-besar-kunjungan-penyakit-rawat-jalan",
        path: "/rekapitulasi-morbiditas/10-besar-kunjungan-penyakit-rawat-jalan",
        component: BesarPenyakitKunjunganRajal,
    },
    {
        name: "rekapitulasi-pelayanan-daftar-rujukan",
        path: "/rekapitulasi-pelayanan/daftar-rujukan",
        component: DaftarRujukan,
    },
];

const router = new VueRouter({
    mode: "history",
    routes: routes,
    linkActiveClass: "active",
});

function authMiddleware(to, from, next) {
    const isAuthenticated = checkAuth(); // Implement your authentication check

    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (!isAuthenticated) {
            next({
                path: "/login",
                query: {
                    redirect: to.fullPath,
                },
            });
        } else {
            next();
        }
    } else {
        next();
    }
}
export default router;
